import { render, staticRenderFns } from "./processAccidentReceptionResult.vue?vue&type=template&id=7961370e"
import script from "./processAccidentReceptionResult.vue?vue&type=script&lang=js"
export * from "./processAccidentReceptionResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7961370e')) {
      api.createRecord('7961370e', component.options)
    } else {
      api.reload('7961370e', component.options)
    }
    module.hot.accept("./processAccidentReceptionResult.vue?vue&type=template&id=7961370e", function () {
      api.rerender('7961370e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/rec/processAccidentReceptionResult.vue"
export default component.exports